import { render } from "./CreateNewAnswerModal.vue?vue&type=template&id=d3125680&scoped=true"
import script from "./CreateNewAnswerModal.vue?vue&type=script&lang=js"
export * from "./CreateNewAnswerModal.vue?vue&type=script&lang=js"

import "./CreateNewAnswerModal.vue?vue&type=style&index=0&id=d3125680&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3125680"]])

export default __exports__